













import Vue from 'vue';
import ProductsOverviewCategoriesItem from './ProductsOverviewCategoriesItem.vue';
import { IProductCategory } from '../../common/interfaces/products.interface';

export default Vue.extend({
  name: `ProductsOverviewCategories`,
  components: { ProductsOverviewCategoriesItem },
  props: {
    categories: {
      required: true,
      type: Array as () => IProductCategory[],
    },
  },
});
